



















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { FormQuestion } from "@/store/modules/types";
import { BTime } from "bootstrap-vue";

@Component({
  components: {
    BTime,
  },
})
export default class TimeAnswer extends Vue {
  @Prop() readonly question!: FormQuestion;
  time: string | null = null;
  @Watch("time")
  onTimeChanged() {
    this.$emit("answer", this.question.id, this.time);
  }
  mounted() {
    const { answer } = this.question;
    if (answer.value) this.time = answer.value;
  }
}
